import React, { useEffect, useState } from "react";
import Layout1 from "../../components/layout1";
import SubHeader from "../../components/subHeader";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { techDetails, updateTechApi } from "../../functions/technicians";
import { loaderReducer } from "../../components/toolkit/loader";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import TwoFactorAuth from "../../components/TwoFactorAuth";
import { Logout } from "../../functions/auth";

const Index = () => {
  const cookies = new Cookies();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userDetails, setUserDetails] = useState({});
  const [checkedInput, setCheckedInput] = useState(false);
  const [apiCallSuccessFullyDone, setApiCallSuccessFullyDone] = useState(false);

  // form local state
  const [formName, setFormName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const token = cookies.get("token");
  const userId = cookies.get("userId");
  const useEmail = cookies.get("userName");
  const cookieName = cookies.get("name");

  const handleLogout = async () => {
    try {
      const response = await Logout();
      if (response?.data?.status === "success") {
        cookies.remove("token", { path: "/" });
        cookies.remove("refreshToken", { path: "/" });
        cookies.remove("userName", { path: "/" });
        cookies.remove("userId", { path: "/" });
        navigate("/");
        toast.success("You have logged out successfully.");
      } else {
        toast.error(response.data?.error || "Logout failed. Please try again.");
      }
    } catch (error) {
      console.error("Logout failed:", error);
      toast.error( error?.response?.data?.message);
    }
  };

  useEffect(() => {
    const handleData = async () => {
      dispatch(loaderReducer(true));
      try {
        const res = await techDetails(token, userId);
        setUserDetails(res.data.user || {});
        setCheckedInput(res.data.user?.hideCompletedOrder || false);
        // initialise editable name from backend (fallback to cookie)
        setFormName(res.data.user?.name || cookieName || "");
        dispatch(loaderReducer(false));
      } catch (err) {
        toast.error(err?.message || err || "Getting some issue, try again.");
        dispatch(loaderReducer(false));
      }
    };

    handleData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, token, apiCallSuccessFullyDone]);

  const handleSaveHideCompletedOrder = async () => {
    const userData = {
      name: cookieName,
      email: useEmail,
      role: userDetails.role,
      hideCompletedOrder: checkedInput,
    };
    dispatch(loaderReducer(true));
    try {
      await updateTechApi(token, userId, userData);
      dispatch(loaderReducer(false));
      setApiCallSuccessFullyDone(true);
      toast.success("Preference saved.");
    } catch (error) {
      toast.error(error?.message || error || "Getting some issue, try again.");
      dispatch(loaderReducer(false));
    }
  };

  const handleSaveProfile = async () => {
    // Basic validation
    if (!formName || formName.trim().length === 0) {
      toast.error("Name cannot be empty.");
      return;
    }

    if (password || confirmPassword) {
      if (password.length < 6) {
        toast.error("Password must be at least 6 characters.");
        return;
      }
      if (password !== confirmPassword) {
        toast.error("Passwords do not match.");
        return;
      }
    }

    const payload = {
      name: formName,
      email: useEmail,
      role: userDetails.role,
      // only send password if user provided one
      ...(password ? { password } : {}),
    };

    dispatch(loaderReducer(true));
    try {
      await updateTechApi(token, userId, payload);
      dispatch(loaderReducer(false));
      toast.success("Profile updated successfully.");

      // update cookie if name changed
      if (formName !== cookieName) {
        cookies.set("name", formName, { path: "/" });
      }

      // clear password fields
      setPassword("");
      setConfirmPassword("");

      // trigger a refresh if needed elsewhere
      setApiCallSuccessFullyDone((s) => !s);
    } catch (error) {
      dispatch(loaderReducer(false));
      toast.error(error?.message || error || "Getting some issue, try again.");
    }
  };

  return (
    <Layout1>
      <SubHeader />
      <div
        className="contentclss w-50"
        style={{ margin: "auto", padding: "4rem 4rem" }}
      >
        <div className="sub2container mt-4">
          <div className="tupdate mt-4">Profile</div>

          {/* Name (editable) */}
          <div>
            <div className="row mt-3">
              <div className="col-lg-3 col-md-4 col-sm-12 sub2head">Name</div>
              <div className="col-lg-9 col-md-8 col-sm-12 position-relative">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formName}
                  onChange={(e) => setFormName(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Email (disabled) */}
          <div>
            <div className="row mt-3">
              <div className="col-lg-3 col-md-4 col-sm-12 sub2head">Email </div>
              <div className="col-lg-9 col-md-8 col-sm-12 position-relative">
                <input
                  type="text"
                  name="email"
                  className="form-control"
                  value={userDetails.email || useEmail || ""}
                  disabled
                />
              </div>
            </div>
          </div>

          {/* Password (optional) */}
          <div>
            <div className="row mt-3">
              <div className="col-lg-3 col-md-4 col-sm-12 sub2head">
                New Password
              </div>
              <div className="col-lg-9 col-md-8 col-sm-12 position-relative">
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  value={password}
                  placeholder="Leave blank to keep current password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Confirm password */}
          <div>
            <div className="row mt-3">
              <div className="col-lg-3 col-md-4 col-sm-12 sub2head">
                Confirm Password
              </div>
              <div className="col-lg-9 col-md-8 col-sm-12 position-relative">
                <input
                  type="password"
                  name="confirmPassword"
                  className="form-control"
                  value={confirmPassword}
                  placeholder="Confirm new password"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Save profile button */}
          <div style={{ marginTop: 16 }}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSaveProfile}
            >
              Save Profile
            </button>
          </div>

          {/* Hide Completed Order */}
          <div>
            <div className="row mt-3">
              <div className="col-lg-3 col-md-4 col-sm-12 sub2head">
                Hide Completed Order
              </div>
              <div className="col-lg-9 col-md-8 col-sm-12 position-relative">
                <input
                  type="checkbox"
                  name="hideOrder"
                  className="form-check-input"
                  checked={checkedInput}
                  onChange={() => setCheckedInput(!checkedInput)}
                />
                <button
                  type="button"
                  className="btn btn-success"
                  style={{ marginLeft: "30px" }}
                  disabled={checkedInput === userDetails.hideCompletedOrder}
                  onClick={handleSaveHideCompletedOrder}
                >
                  Save
                </button>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <TwoFactorAuth />
          </div>

          <div
            className="contd mt-4 mb-4"
            style={{ margin: "auto" }}
            onClick={handleLogout}
          >
            Logout User
          </div>
        </div>
      </div>
    </Layout1>
  );
};

export default Index;

